module.exports = __webpack_public_path__ + "static/media/coffeebar_thumb_even.9692f75b.jpg";